<template>
  <div class="cascaderAreaBox">
    <div class="cascaderArea">
      <el-select
        v-model="select.country"
        placeholder="请选择国家"
        @change="changeCountry"
        class="middle-select"
      >
        <el-option value label="不限"></el-option>
        <el-option
          v-for="item in list.countrys"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        ></el-option>
      </el-select>
      <el-select
        v-model="select.province"
        placeholder="请选择省份"
        @change="changeProvince"
        class="middle-select"
      >
        <el-option value label="不限"></el-option>
        <el-option
          v-for="item in list.provinces"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        ></el-option>
      </el-select>
      <el-select
        v-model="select.city"
        placeholder="请选择地区"
        @change="changeCity"
        class="middle-select"
      >
        <el-option value label="不限"></el-option>
        <el-option
          v-for="item in list.citys"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { getCityAll } from '@/api/common'
export default {
  props: {
    country: {
      type: String
    },
    province: {
      type: String
    },
    city: {
      type: String
    }
  },
  watch: {
    country: function (newVal) {
      this.select.country = newVal
      // this.changeCountry(newVal)
    },
    province: function (newVal) {
      this.select.province = newVal
      // this.changeProvince(newVal)
    },
    city: function (newVal) {
      this.select.city = newVal
      // this.changeCity(newVal)
    }
  },
  data() {
    return {
      list: {
        countrys: [],
        provinces: [],
        citys: []
      },
      select: {
        country: null,
        province: null,
        city: null
      }
    }
  },
  created() {
    this.list.countrys = sessionStorage.getItem('area')
    if (this.list.countrys) {
      this.list.countrys = JSON.parse(sessionStorage.getItem('area'))
    } else {
      this.search()
    }
  },
  methods: {
    async search() {
      this.list.countrys = sessionStorage.getItem('area')
      if (!this.list.countrys) {
        const { data: res } = await getCityAll()
        if (res.resultCode === 200) {
          sessionStorage.setItem('area', JSON.stringify(res.data))
          this.list.countrys = res.data
        } else {
          this.$message.error('获取地区信息失败!')
        }
      } else {
        this.list.countrys = JSON.parse(sessionStorage.getItem('area'))
      }
      if (this.country) {
        this.select.country = this.country
        this.changeCountry(this.country)
      }
      if (this.province) {
        this.select.province = this.province
        this.changeProvince(this.province)
      }
      if (this.city) {
        this.select.city = this.city
        this.changeCity(this.city)
      }
    },
    changeCountry(val) {
      this.list.provinces = []
      this.list.citys = []
      this.list.countrys.forEach((item) => {
        if (item.name === val) {
          this.list.provinces = item.cityResults
        }
      })

      this.select.province = ''

      this.select.city = ''

      this.$emit('searchArae', { ...this.select })
    },
    changeProvince(val) {
      this.list.citys = []

      this.list.provinces.forEach((item) => {
        if (item.name === val) {
          this.list.citys = item.cityResults
        }
      })

      this.select.city = ''

      this.$emit('searchArae', { ...this.select })
    },
    changeCity() {
      this.$emit('searchArae', { ...this.select })
    },
    clear() {
      this.select = {
        country: '',
        province: '',
        city: ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.cascaderAreaBox {
  width: 430px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.cascaderArea {
  width: 420px;
  height: 32px;
  line-height: 32px !important;
  .el-select {
    margin-right: 10px;
  }
}
/deep/.el-input--suffix {
  height: 32px;
}
/deep/.el-input__icon {
  line-height: 32px;
}
/deep/ .el-input__inner {
  // border: 1px solid #17757A;
  // color:#17757A;
  height: 32px;
  line-height: 32px;
}
/deep/.el-input__inner {
  width: 130px !important;
  border: 1px solid #e6e6e6 !important;
  border-radius: 4px !important;
  height: 32px !important;
}
/deep/ .middle-select,
.middle-input {
  width: 130px !important;
}
/deep/ .el-input__inner:hover {
  border-color: #17757a;
}
/deep/ .el-select-dropdown__item {
  color: #17757a !important;
}
</style>
